// 拥有看板权限的学校id列表
export const dashboardSchoolList = ["59977128740917248-1","190753622680670208-1"]

// 拥有看板V2权限的学校id列表
export const dashboardV2SchoolList = ["59977128740917248-1","190753622680670208-1"]
